import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LandPage from './pages/LandPage';
import HousesForSalePage from './pages/HousesForSalePage';
import HousesForRentPage from './pages/HousesForRentPage';
import CarsPage from './pages/CarsPage';
import AdminPage from './pages/AdminPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ListerLoginPage from './pages/ListerLoginPage';
import ListerSignupPage from './pages/ListerSignupPage';
import ListerDashboardPage from './pages/ListerDashboardPage';
import MyUnlocksPage from './pages/MyUnlocksPage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div style={{ minHeight: '100vh', background: '#080808' }}>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/land" element={<LandPage />} />
          <Route path="/houses-for-sale" element={<HousesForSalePage />} />
          <Route path="/houses-for-rent" element={<HousesForRentPage />} />
          <Route path="/cars" element={<CarsPage />} />
          <Route path="/oss-sntm" element={<AdminPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/lister-login" element={<ListerLoginPage />} />
          <Route path="/lister-signup" element={<ListerSignupPage />} />
          <Route path="/lister-dashboard" element={<ListerDashboardPage />} />
          <Route path="/my-unlocks" element={<MyUnlocksPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;